import React from "react";
import Carousel from 'react-bootstrap/Carousel';
import "./pagestyle.css";

function ImageCarousel() {
    return (
        <div className="Center h-100">
            <Carousel>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-01 img d-block m-auto'
                        src='jamboretz-anne-carmelita.png'
                        alt='Carmelita'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Carmelita, 8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-02 img d-block m-auto'
                        src='jamboretz-anne-osa.png'
                        alt='Osa'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Osa, 8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-03 img d-block m-auto'
                        src='jamboretz-anne-catstare.png'
                        alt='Cat Stare'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-1 img d-block m-auto'
                        src='jamboretz-anne-doubleguitar.png'
                        alt='Double Guitar'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Jimmy Page, 13.5x14", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-2 img d-block m-auto'
                        src='jamboretz-anne-boxer.png'
                        alt='Boxer'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Kokua, 8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-04 img d-block m-auto'
                        src='jamboretz-anne-foxylady.png'
                        alt='Foxy Lady'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Foxy Lady, 8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-05 img d-block m-auto'
                        src='jamboretz-anne-catcouch.png'
                        alt='Cat Couch'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-2.5 img d-block m-auto'
                        src='jamboretz-anne-greeneyecat.png'
                        alt='Green Eye Cat'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-3 img d-block m-auto'
                        src='jamboretz-anne-cat.png'
                        alt='Cat'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-4 img d-block m-auto'
                        src='jamboretz-anne-reef.png'
                        alt='Reef'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Reef, 7.32x13", oil paint on canvas</p>
                        <p></p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-5 img d-block m-auto'
                        src='jamboretz-anne-boxerpuppy.png'
                        alt='Boxer Puppy'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-6 img d-block m-auto'
                        src='jamboretz-anne-buffalo.png'
                        alt='Buffalo'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Four Wildebeest, 10x8", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-5 img d-block m-auto'
                        src='jamboretz-anne-romeophebe.png'
                        alt='Romeo and Phebe'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Romeo and Phebe, 8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-7 img d-block m-auto'
                        src='jamboretz-anne-hounds.png'
                        alt='Hounds'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-8 img d-block m-auto'
                        src='jamboretz-anne-fatcat.png'
                        alt='Fat Cat'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Sid, 8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-9 img d-block m-auto'
                        src='jamboretz-anne-twodogs.png'
                        alt='Two Dogs'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-10 img d-block m-auto'
                        src='jamboretz-anne-basset.png'
                        alt='Basset Hound'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-11 img d-block m-auto'
                        src='jamboretz-anne-dogandgirl.png'
                        alt='girlanddog'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>8x10", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-12 img d-block m-auto'
                        src='jamboretz-anne-coco.png'
                        alt='Coco'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Coco, 10.66x14", oil paint on stretched canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-13 img d-block m-auto'
                        src='jamboretz-anne-forestfire.png'
                        alt='Forest Fire'
                    />
                    <div className="image-overlay"></div>
                    {/* <Carousel.Caption>
                        <h3>Forest Fire</h3>
                        <p>Anne Jamboretz Copyright 2020 &copy;</p>
                    </Carousel.Caption> */}
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-14 img d-block m-auto'
                        src='jamboretz-anne-guitarist.png'
                        alt='Guitarist'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Buddy Guy, 8.29x7", oil paint on canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-15 img d-block m-auto'
                        src='jamboretz-anne-city.png'
                        alt='City'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>The City, 10x10.81", oil paints and pastels on canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item className="carousel-item">
                    <img
                        className='number-16 img d-block m-auto'
                        src='jamboretz-anne-soundofjazz.png'
                        alt='Sound of Jazz'
                    />
                    <div className="image-overlay"></div>
                    <Carousel.Caption>
                        <p>Four Musicians, 9x9.26", oil paint on canvas</p>
                    </Carousel.Caption>
                </Carousel.Item>

            </Carousel>
        </div>
    );
}

export default ImageCarousel;